import { render } from "./ScreenTitle.vue?vue&type=template&id=479e8ae3"
const script = {}

import "./ScreenTitle.vue?vue&type=style&index=0&id=479e8ae3&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__